import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { Observable } from 'rxjs/Observable';
import { Utility } from '../../../common/utility';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { PatientUrl} from '../../../shared/urls/patient.url';
@Injectable()
export class AttachmentService {
    constructor(public baseService: BaseService) {
    }
    getConsultationAttachment(consultationId: string, paitentId: string) {
        const url = ConsultationUrl.CONSULTATION_HISTORY_ATTACHMENT;
        return this.baseService.getData(url, { consultationId: consultationId, paitentId: paitentId });
    }
    uploadAttachment(consultationId: string, uploadFile: any) {
        const url = Utility.stringFormat(ConsultationUrl.CONSULTATION_ATTACHMENT, [consultationId]);
        return this.baseService.upload(url, uploadFile);
    }
    removeAttachment(fileId: string) {
        const url = Utility.stringFormat(ConsultationUrl.CONSULTATION_ATTACHMENT_REMOVE, [fileId]);
        return this.baseService.delete(url);
    }
    setShareStatus(fileId: string, isShared: boolean) {
      const url = Utility.stringFormat(ConsultationUrl.CONSULTATION_ATTACHMENT_SHARED, [fileId]) + '?isShared=' + isShared;
      return this.baseService.update(url, null);
    }
    getPatientEmail(patientId: string) {
      const url = Utility.stringFormat(PatientUrl.GET_PATIENT_EMAIL, [patientId]);
      return this.baseService.getData(url);
    }
    sendEmailNewUploadedDocuments(patientId: string, consultationId : string) {
      const url = Utility.stringFormat(PatientUrl.EMAIL_NEW_UPLOADED_DOCUMENTS, [patientId, consultationId]);
      return this.baseService.postData(url, { patientId: patientId });
    }

    downloadFile(id) {
      const url = PatientUrl.PATIENT_DOWNLOAD_ATTACHMENT + '?id=' + id;
      return this.baseService.downloadFile(url);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/attachment/attachment.service.ts